import React from 'react';
import { Link } from 'react-router-dom';
import { Product } from '../../data/products';
import './ProductCard.css';

interface ProductCardProps {
  product: Product;
}

const ProductCard: React.FC<ProductCardProps> = ({ product }) => {
  const href = `/${product.category}/${product.handle}`;
  const hasSecondImage = product.images.length > 1;

  return (
    <Link to={href} className="product-card" aria-label={`${product.title} — ${product.price}`}>
      <div className="product-card__image-wrap">
        <img
          src={product.images[0]}
          alt={product.title}
          className="product-card__image product-card__image--primary"
          width={400}
          height={500}
          loading="lazy"
        />
        {hasSecondImage && (
          <img
            src={product.images[1]}
            alt={`${product.title} — alternate view`}
            className="product-card__image product-card__image--hover"
            width={400}
            height={500}
            loading="lazy"
            aria-hidden="true"
          />
        )}
        {product.badge && (
          <span className="product-card__badge">{product.badge}</span>
        )}
      </div>
      <div className="product-card__info">
        {product.scentFamily && (
          <span className="product-card__meta">{product.scentFamily}</span>
        )}
        <h3 className="product-card__name">{product.title}</h3>
        <span className="product-card__price">{product.price}</span>
      </div>
    </Link>
  );
};

export default ProductCard;
